
import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { EmpresasService } from "../../../../../../shared/services/empresas.service";
import { MarcaService } from "../../../../../../shared/services/marca.service";
import { PropietarioService } from "../../../../../../shared/services/propietarios.service";
import { TiposService } from "../../../../../../shared/services/tipos.service";
import { VehiclesService } from "../../../../../../shared/services/vehicles.service";
import { RelacionService } from "../../../../../../shared/services/relacion.service";
import { ModelosService } from "../../../../../../shared/services/modelos.service";
import { CombustibleService } from "../../../../../../shared/services/combustible.service";
import { TipoServicioService } from "../../../../../../shared/services/tiposervicio.service";
import { TiposerviciosDocumentosService } from "../../../../../../shared/services/tiposerviciosdocumento.service";
import { ConductorVehiculoService } from "../../../../../../shared/services/conductor.service";
import { TarjetaOperacionService } from "../../../../../../shared/services/tarjeta-operaciones.service";
import { HistorialSoatService, } from "../../../../../../shared/services/historial_soat.service";
import { HistorialCdaService, } from "../../../../../../shared/services/historial_cda.service";
import { HistorialExtintorService, } from "../../../../../../shared/services/historial_extintor.service";
import { HistorialRevisionBimestralService, } from "../../../../../../shared/services/historial_bimestral.service";
import { HistorialContractualService } from "../../../../../../shared/services/historial_contractual.service";
import { HistorialExtraContractual, HistorialExtraContractualService } from "../../../../../../shared/services/historial_extracontractual.service";
import { HistorialTodoRiesgoService } from "../../../../../../shared/services/historial_todo_riesgo.service";
import { FormBuilder, FormGroup, ValidatorFn, Validators,AbstractControl } from "@angular/forms";
import { NgbAccordion, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { NgbdSortableHeader } from "../../../../../../shared/directives/NgbdSortableHeader";
import { ActivatedRoute, Router } from "@angular/router";
import { Utils } from "../../../../../../shared/utils/Utils";
import { forkJoin } from "rxjs";
import { DataService } from "../../../../../../shared/services/municipios.service";
import { AdministracionService } from "../../../../../../shared/services/administracion.services";
import { Siniestro, SiniestrosService } from "../../../../../../shared/services/siniestrosViales.service";
declare var require;
const Swal = require("sweetalert2");

@Component({
  selector: "app-editar-vehiculo",
  templateUrl: "./editar-vehiculo.component.html",
  styleUrls: ["./editar-vehiculo.component.scss"],
})
export class EditarVehiculoComponent {


  @ViewChild("inputServicio") inputServicio!: ElementRef;
  @ViewChild("inputPlaca") inputPlaca!: ElementRef;
  @ViewChild("inputInterno") inputInterno!: ElementRef;
  @ViewChild("inputEmpresa") inputEmpresa!: NgSelectComponent;
  @ViewChild("inputClase") inputClase!: NgSelectComponent;
  @ViewChild("inputMarca") inputMarca!: NgSelectComponent;
  @ViewChild("inputModelo") inputModelo!: NgSelectComponent;
  @ViewChild("inputRelacion") inputRelacion!: NgSelectComponent;
  @ViewChild("inputPassword") inputPassword!: ElementRef;
  @ViewChild("inputTarjeta") inputTarjeta!: ElementRef;
  @ViewChild("inputFechaExpedicionTarjeta") inputFechaExpedicionTarjeta!: ElementRef;
  @ViewChild("inputFechaVencimientoTarjeta") inputFechaVencimientoTarjeta!: ElementRef;
  @ViewChild("inputAseguradoraSoat") inputAseguradoraSoat!: ElementRef;
  @ViewChild("inputNumeroSoat") inputNumeroSoat!: ElementRef;
  @ViewChild("inputFechaExpedicionSoat") inputFechaExpedicionSoat!: ElementRef;
  @ViewChild("inputFechaVencimientoSoat") inputFechaVencimientoSoat!: ElementRef;
  @ViewChild("inputValorSoat") inputValorSoat!: ElementRef;
  @ViewChild("inputTarifaSoat") inputTarifaSoat!: ElementRef;
  @ViewChild("inputCertificadoCda") inputCertificadoCda!: ElementRef;
  @ViewChild("inputCentroCda") inputCentroCda!: ElementRef;
  @ViewChild("inputFechaExpedicionCda") inputFechaExpedicionCda!: ElementRef;
  @ViewChild("inputFechaVencimientoCda") inputFechaVencimientoCda!: ElementRef;
  @ViewChild("inputIdExtintor") inputIdExtintor!: ElementRef;
  @ViewChild("inputFreCargaExtintor") inputFreCargaExtintor!: ElementRef;
  @ViewChild("inputVencimientoExtintor") inputVencimientoExtintor!: ElementRef;
  @ViewChild("inputCentroDiagnosticoBim") inputCentroDiagnosticoBim!: ElementRef;
  @ViewChild("inputRevisionBim") inputRevisionBim!: ElementRef;
  @ViewChild("inputUltimaRevisionBim") inputUltimaRevisionBim!: ElementRef;
  @ViewChild("inputProximaRevisionBim") inputProximaRevisionBim!: ElementRef;
  @ViewChild("inputAseguradoraCont") inputAseguradoraCont!: ElementRef;
  @ViewChild("inputIntermediaCont") inputIntermediaCont!: ElementRef;
  @ViewChild("inputFechaExpedicionCont") inputFechaExpedicionCont!: ElementRef;
  @ViewChild("inputFechaVencimientoCont") inputFechaVencimientoCont!: ElementRef;
  @ViewChild("inputNumeroCont") inputNumeroCont!: ElementRef;
  @ViewChild("inputAseguradoraCont") inputAseguradoraExt!: ElementRef;
  @ViewChild("inputIntermediaCont") inputIntermediaExt!: ElementRef;
  @ViewChild("inputFechaExpedicionCont") inputFechaExpedicionExt!: ElementRef;
  @ViewChild("inputFechaVencimientoCont") inputFechaVencimientoExt!: ElementRef;
  @ViewChild("inputNumeroCont") inputNumeroExt!: ElementRef;
  @ViewChild("inputAseguradoraCont") inputAseguradoraTd!: ElementRef;
  @ViewChild("inputFechaExpedicionCont") inputFechaExpedicionTd!: ElementRef;
  @ViewChild("inputFechaVencimientoCont") inputFechaVencimientoTd!: ElementRef;
  @ViewChild("inputNumeroCont") inputNumeroTd!: ElementRef;
  @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  public Revision = [
    { value: "1", label: "SI" },
    { value: "0", label: "NO" },
  ];
  public revision!: string; // Aquí se almacena el valor seleccionado del <ng-select>

  activePanel: string[] = ["static-1"]; // El panel se abre por defecto
  formData: any = {}; // Inicializar vacío para evitar errores
  empresas!: any[];
  todasLasEmpresas: any;
  marcas: any;
  tipos: any;
  propietarios: any;
  formNuevo!: FormGroup;
  validate: boolean = false;
  errores: any = {};
  relaciones: any;
  modelos: any;
  formTarjeta!: FormGroup;
  formSoat!: FormGroup;
  formCda!: FormGroup;
  formExtintor!: FormGroup;
  empresasaseguradora: any;
  empresascda: any;
  formBimestral!: FormGroup;
  formContractual!: FormGroup;
  formExtracontractual!: FormGroup;
  formTodoriesgo!: FormGroup;
  combustibles: any;
  editMode!: boolean;
  formEmpresa!: FormGroup;
  empresaselecionada: any;
  formClase!: FormGroup;
  claseselecionada: any;
  tiposervicio: any;
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;

  validarTO: boolean = false; // Variable de control para el ngIf
  validarBIM: boolean = false;
  validarLT: boolean = false;
  validarRCC: boolean = false;
  validarSOAT: boolean = false;
  validarCDA: boolean = false;
  validarRCE: boolean = false;
  validarPTR: boolean = false;
  vehicle: any;
  extintor: any;
  editarSeleccion: any;
  formConductor!: FormGroup;
  conductores: any;
  tarjetaOperacion: any[] = [];
  conductoresDisponibles = false;
  siniestrosDisponibles = false;
  documentosActivos: string[] = [];
  tarjetaSeleccionada: any;
  soatList: any;
  soatSeleccionado: any;
  estadisticas: any = {};
  placaSeleccionada: any;
  botonListarDisponible: boolean = false;
  historialCda: any;
  cdaSelecionado: any;
  historialExtintor: any;
  estadisticasExtintor: any;
  extintorSeleccionado: any;
  historialBimestral: any;
  estadisticasBimestral: any;
  bimestralSeleccionado: any;
  centroDiagnosticoSeleccionado: any;
  historialContractual: any;
  estadisticasContractual: any;
  contractualSeleccionado: any;
  historialExtracontractual: any;
  estadisticasExtracontractual: any;
  extraSeleccionado: any;
  historialTodoRiesgo: any;
  estadisticasTodoRiesgo: any;
  todoRiesgoSeleccionado: any;
  listaCDA: any;
  modalEmpresaRef!: NgbModalRef;
  mostrarFechaConvenio = false;
  empresaAdministrativaNit: string | null = null;
  empresaAdministrativaNombre: string | null = null;
  autoSeleccionEmpresaAdministrativaPendiente = false;
  editarPassword: boolean = false; // Controla si se puede editar
  mostrarPassword: boolean = false; // Controla si se ve la contraseña
  municipios: any;
  maxDate!: string;
  minDate!: string;
  siniestros: any;
  vehiculo: any;


  constructor(
    private empresasService: EmpresasService,
    private marcaService: MarcaService,
    private tiposService: TiposService,
    private propietariosService: PropietarioService,
    private vehiclesService: VehiclesService,
    private relacionService: RelacionService,
    private modelosService: ModelosService,
    private combustibleService: CombustibleService,
    private tiposervicioService: TipoServicioService,
    private modalService: NgbModal,
    private tiposerviciodocumentoService: TiposerviciosDocumentosService,
    private conductorService: ConductorVehiculoService,
    private tarjetaoperacionesService: TarjetaOperacionService,
    private historialSoatService: HistorialSoatService,
    private historialCdaService: HistorialCdaService,
    private siniestrosService: SiniestrosService,
    private historialExtintorService: HistorialExtintorService,
    private historialBimestralService: HistorialRevisionBimestralService,
    private historialContractualService: HistorialContractualService,
    private historialExtraContractualService: HistorialExtraContractualService,
    private historialTodoRiesgoService: HistorialTodoRiesgoService,
    private fb: FormBuilder,
    private dataService: DataService,
    private administracionService: AdministracionService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  

  ngOnInit() {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    this.minDate = formattedDate;
    this.maxDate = formattedDate;

    this.formNuevo = this.createFormNuevo();
    this.formTarjeta = this.createFormTarjeta();
    this.formSoat = this.createFormSoat();
    this.formCda = this.createFormCda();
    this.formExtintor = this.createFormExtintor();
    this.formBimestral = this.createFormBimestral();
    this.formContractual = this.createFormContractual();
    this.formExtracontractual = this.createFormExtracontractual();
    this.formTodoriesgo = this.createFormTodoriesgo();
    this.formEmpresa = this.createFormEmpresa();
    this.formClase = this.createFormClase();

    this.formNuevo.get('Idpropietario')?.valueChanges.subscribe((value) => {
      this.onPropietarioChange(value);
    });

        // Configurar validación delayed para afiliación
    this.setupAfiliacionValidation();

    this.cargarCiudades();
    this.loadDatosPrincipales();
    this.loadEmpresas();
    this.cargarEmpresaAdministrativa();
    this.suscribirseFecha(this.formSoat, 'fecha_soat', 'vencimiento_soat', { anioCompleto: true }); //SOAT
    this.suscribirseFecha(this.formBimestral, 'ultima_revision', 'proxima_revision', { dias: 60 });  //BIM
    this.suscribirseFecha(this.formCda, 'fechacda', 'vcda', { anioCompleto: true });//CDA 
    this.suscribirseFecha(this.formExtintor, 'frecarga', 'vrecarga', { anioCompleto: true }); //EXTINTOR
    this.suscribirseFecha(this.formContractual, 'fecha_expedicionRCC', 'fecha_vencimientoRCC', { anioCompleto: true }); //RCC
    this.suscribirseFecha(this.formExtracontractual, 'fecha_expedicionRCE', 'fecha_vencimientoRCE', { anioCompleto: true }); //RCC
    this.suscribirseFecha(this.formTodoriesgo, 'fecha_expedicionTD', 'fecha_vencimientoTD', { anioCompleto: true }); //RCC

    const placaRecibida = this.route.snapshot.paramMap.get("placa");
    if (placaRecibida) {
      // Modo edición: establecemos editMode en true
      this.editMode = true;
      // Se asigna la placa al formulario
      this.formNuevo.patchValue({ placa: placaRecibida });
    }
    this.buscarVehiculo();

    const servicioSeleccionado = this.formNuevo.controls["servicio"].value;
    if (servicioSeleccionado) {
      this.ValidarDocumentosPorId(servicioSeleccionado);
    }
  }

  private suscribirseFecha(form: FormGroup, campoOrigen: string, campoDestino: string, config: { anioCompleto?: boolean, dias?: number }) {
    form.get(campoOrigen)?.valueChanges.subscribe((fechaStr: string) => {
      if (!fechaStr) return;

      const fecha = new Date(fechaStr);
      let nuevaFecha: Date;

      if (config.anioCompleto) {
        nuevaFecha = new Date(fecha);
        nuevaFecha.setFullYear(nuevaFecha.getFullYear() + 1);
        nuevaFecha.setDate(nuevaFecha.getDate() - 1); // Un día antes
      } else if (config.dias) {
        nuevaFecha = new Date(fecha);
        nuevaFecha.setDate(nuevaFecha.getDate() + config.dias);
      } else {
        return;
      }

      const nuevaFechaStr = nuevaFecha.toISOString().substring(0, 10);
      form.get(campoDestino)?.setValue(nuevaFechaStr, { emitEvent: false });
    });
  }

  private loadDatosPrincipales() {
    forkJoin({
      marcas: this.marcaService.getMarcas(),
      tipos: this.tiposService.getTipos(),
      relaciones: this.relacionService.getRelaciones(),
      propietarios: this.propietariosService.getPropietarios(),
      modelos: this.modelosService.getModelos(),
      combustibles: this.combustibleService.getAllCombustibles(),
      tiposervicio: this.tiposervicioService.getTipoServicios()
    }).subscribe({
      next: ({
        marcas,
        tipos,
        relaciones,
        propietarios,
        modelos,
        combustibles,
        tiposervicio
      }) => {
        this.marcas = marcas;
        this.tipos = tipos;
        this.relaciones = relaciones;
        this.propietarios = propietarios.propietarios; // según tu API
        this.asegurarPropietarioEmpresaAdministrativa();
        this.onPropietarioChange(this.formNuevo.get('Idpropietario')?.value);
        this.modelos = modelos;
        this.combustibles = combustibles;

        // Lógica especial para tiposervicio
        if (tiposervicio && tiposervicio.length > 0) {
          this.tiposervicio = tiposervicio.sort((a, b) =>
            a.Descripcion === 'Particular' ? -1 : 1
          );

          const particular = this.tiposervicio.find(
            serv => serv.Descripcion === 'Particular'
          );

          if (particular) {
            this.formNuevo.get('servicio')?.setValue(particular.idServicio);
          }
        }
      },
      error: (err) => {
        console.error('Error al cargar datos del catálogo:', err);
      }
    });
  }

  private loadEmpresas() {
   // console.log('Cargando empresas...');


    // Mejorar: cargar ambas listas en paralelo y manejar errores de forma clara
    forkJoin({
      aseguradoras: this.empresasService.getEmpresasPorTipo('aseguradora', 1),
      cda: this.empresasService.getEmpresasPorTipo('cda', 1),
      empresasTransporte: this.empresasService.getEmpresasPorTipo('transporte', 1)
    }).subscribe({
      next: ({ aseguradoras, cda, empresasTransporte }) => {
        this.empresasaseguradora = aseguradoras;
        this.empresascda = cda;
        this.empresas = empresasTransporte;
      
      },
      error: (err) => {
        console.error("Error al obtener empresas aseguradoras o CDA:", err);
        // Opcional: puedes mostrar un mensaje de error al usuario aquí
      }
    });
  }

  // Función para reiniciar el formulario de vehículo
  onSubmit() {
    if (this.formNuevo.valid) {
    } else {
      // console.log("Formulario inválido");
    }
    if (this.formConductor.valid) {
      const conductorId = this.formConductor.value.conductor_id;
      //console.log("Conductor seleccionado:", conductorId);
      // Aquí puedes proceder con la lógica para guardar o utilizar la selección
    }
  }

  buscarVehiculo() {
    const placa = this.formNuevo.get("placa")?.value;
    if (!placa) return;

    this.vehiclesService.getVehicleByPlaca(placa).subscribe({
      next: (vehicleData) => {
        if (!vehicleData) return;
       //  console.log(vehicleData) ;
        this.vehicle = vehicleData;
        this.editarSeleccion = { placa: vehicleData.placa };
        this.placaSeleccionada = vehicleData.placa;
     //   console.log(vehicleData);
        
        //valido la relacion del vehiculo si es un tercero muesta la fecha de convenio
        if (vehicleData.relacion){ 
          this.mostrarFechaConvenio =   vehicleData.relacion=== 8 ;
          
        }

        if (vehicleData.servicio) {
          this.ValidarDocumentosPorId(Number(vehicleData.servicio));
        }

        this.cargarDocumentosPorPlaca(vehicleData.placa);
        this.actualizarFormularios(vehicleData);
      },
      error: (error) => {
        console.error("Error al buscar vehículo:", error);
      }
    });
  }

  private cargarDocumentosPorPlaca(placa: string) {
    const funciones = [
      this.listarConductor,
      this.listarTarjetaOperaciones,
      this.listarSoats,
      this.listarCda,
      this.listarExtintor,
      this.listarBimestral,
      this.listarContractual,
      this.listarExtracontractual,
      this.listarTodoRiesgo,
      this.cargarSiniestroByPlaca,
    ];

    funciones.forEach(fn => fn.call(this, placa));
  }

  private actualizarFormularios(vehicle: any) {

    //console.log( vehicle.sucursal);
    // Formulario principal
    this.formNuevo.patchValue({
      placa: vehicle.placa || "",
      servicio: vehicle.servicio ? Number(vehicle.servicio) : "",
      interno: (vehicle.interno || ""),
      afiliacion: vehicle.afiliacion || "",
      nitEmpresa: vehicle.nitEmpresa || "",
      estado: vehicle.estado || "",
      clase: vehicle.clase || "",
      marca: vehicle.marca || "",
      modelo: vehicle.modelo || "",
      relacion: vehicle.relacion || "",
      Idpropietario: vehicle.Idpropietario || "",
      sucursal: vehicle.sucursal ? Number(vehicle.sucursal) : "",
      convenio: vehicle.convenio || null,
      password: "", // Nunca cargar la clave actual
      matricula: vehicle.matricula || null,
      organismo: vehicle.organismo || "",
      fechalict: vehicle.fechalict || null,
      linea: vehicle.linea || "",
      cilindraje: vehicle.cilindraje || null,
      motor: vehicle.motor || "",
      titular: vehicle.titular || "",
      capacidad: vehicle.capacidad || null,
      color: vehicle.color || "",
      serie: vehicle.serie || "",
      chasis: vehicle.chasis || "",
      vin: vehicle.vin || "",
      carroceria: vehicle.carroceria || "",
      combustible: vehicle.combustible ?? null,
      observaciones: vehicle.observaciones || "",
      kilometraje: vehicle.kilometraje || 0
    });

    // Formulario de empresa
    const empresa = vehicle.empresaDetalle || {};
    this.formEmpresa.patchValue({
      nit: empresa.nit || "",
      digito: empresa.digito || "",
      nombre: empresa.nombre || "",
      direccion: empresa.direccion || "",
      ciudad: empresa.ciudad || "",
      telefono: empresa.telefono || "",
      celular: empresa.celular || "",
      email: empresa.email || "",
      observaciones: empresa.observaciones || "",
      eps: empresa.eps || false,
      arl: empresa.arl || false,
      afp: empresa.afp || false,
      ces: empresa.ces || false,
      ccf: empresa.ccf || false,
      bancos: empresa.bancos || false,
      transporte: empresa.transporte || false,
      colegio: empresa.colegio || false,
      cda: empresa.cda || false,
      taller: empresa.taller || false,
      eds: empresa.eds || false,
      contratista: empresa.contratista || false,
      proveedor: empresa.proveedor || false,
      aseguradora: empresa.aseguradora || false,
      almacen: empresa.almacen || false,
      serviteca: empresa.serviteca || false,
      estado: empresa.estado ?? 1,
    });

    // Formulario de clase
    const clase = vehicle.claseDetalle || {};
    this.formClase.patchValue({
      tipos: clase.tipos || "",
    });
  }

  Actualizar() {
    // Validar formulario antes de proceder
    
    const vehicleData = { ...this.formNuevo.value };
    const placa = this.editarSeleccion?.placa;

    if (!placa) {
      return this.mostrarAlerta("Error", "Placa no encontrada. No se puede actualizar.", "error");
    }

    if (!this.editMode) {
      return this.mostrarAlerta("Error", "No está en modo edición.", "error");
    }

    // Validaciones específicas adicionales
    if (!this.validarCamposObligatorios()) {
      return;
    }

    // Si el campo password está vacío, no lo enviamos (no se repisa)
    if (vehicleData.password === "" || vehicleData.password == null) {
      delete vehicleData.password;
    }

   // console.log("Datos a actualizar:", vehicleData);
    this.vehiclesService.updateVehicle(placa, vehicleData).subscribe({
      next: () => {
        this.mostrarAlerta(
          "Actualización exitosa",
          "El vehículo se actualizó correctamente.",
          "success"
        );

        // Recargar la información actualizada
        this.buscarVehiculo();
      },
      error: (error) => {
        console.error("Error al actualizar el vehículo:", error);

        const mensaje =
          error?.error?.message ??
          error?.error?.error ??
          error?.message ??
          "No fue posible actualizar el vehículo. Inténtelo nuevamente.";

        this.mostrarAlerta("Error", mensaje, "error");
      },
    });
  }

listarConductor(placa: string): void {
  this.conductorService.getConductoresPorPlaca(placa).subscribe({
    next: (data) => {
      this.conductores = data;
      this.conductoresDisponibles = this.conductores.length > 0;
    },
    error: (err) => {
      console.error("Error cargando conductores", err);
      this.conductores = []; // limpia en caso de error
      this.conductoresDisponibles = false;
    }
  });
}

  estadoDeshabilitado = true;

  guardarConductor() {
    const conductor_id = this.formNuevo.get("conductor.conductor_id")?.value?.toString();
    const placa = this.formNuevo.get("placa")?.value;

    if (!conductor_id || !placa) {
      console.error("Faltan datos", { conductor_id, placa });
      return this.mostrarAlerta("Faltan datos", "Debe seleccionar un conductor y una placa válida.", "error");
    }

    this.conductorService.createConductorVehiculo(conductor_id, placa).subscribe({
      next: () => {
        this.mostrarAlerta("Éxito", "Conductor asignado con éxito al vehículo", "success");
        this.listarConductor(placa);//Refrescar lista
      },
      error: (error) => {
        if (error.status === 409) {
      this.mostrarAlerta("Advertencia", error.error?.error || "Ya existe esa asignación.","info");
    } else {
      this.mostrarAlerta("Error", "No se pudo asignar el conductor.", "error");
    }
      }
    });
  }

  avisoInactivarConductor(id: number) {
    console.log("Inactivar conductor con ID:", id);

     const placa = this.formNuevo.get("placa")?.value;
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar el conductor?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (!result.isConfirmed) return;

  
      this.conductorService.deleteConductorVehiculo(id).subscribe({
        next: () => {
          this.mostrarAlerta("¡Éxito!", "Conductor inactivado .", "success");
          this.listarConductor(placa);
        },
        error: (error) => {
          console.error("Error:", error);
          this.mostrarAlerta("Error", error.error?.message || "No se pudo inactivar el conductor.", "error");
        }
      });
    });
  }

  onDateSelect(event: any): void {
    // Convierte la fecha seleccionada a formato 'yyyy-MM-dd'
    const fechaFormateada = `${event.year}-${String(event.month).padStart(
      2,
      "0"
    )}-${String(event.day).padStart(2, "0")}`;
    this.formNuevo.get("registro")?.setValue(fechaFormateada);
  }

  togglePanel(panelId: string) {
    this.activePanel = this.activePanel.includes(panelId) ? [] : [panelId];
  }

  openModalEmpresa(content: any, empresa?: any): void {
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formEmpresa.reset(); // Limpia el formulario para un nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalEmpresaRef = modalRef;
  }

  guardarEmpresa(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = this.formEmpresa.value;
    const email = datos.email;

         if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return this.mostrarAlerta("Email inválido", "Correo no válido. Ej: usuario@dominio.com", "info");
    }
  

    if (!this.formEmpresa.get('nit')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un número de documento", "info");
      this.inputNit?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('digito')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un digito de verificación", "info");
      this.inputCodigo?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('nombre')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un nombre", "info");
      this.inputNombre?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('direccion')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una dirección", "info");
      this.inputDireccion?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('ciudad')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una ciudad", "info");
      this.inputCiudad?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('celular')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un número de celular", "info");
      this.inputCelular?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('email')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un correo electronico", "info");
      this.inputEmail?.nativeElement.focus();
      return;
    }

    if (!this.validarTipoEmpresaSeleccionado()) {
      return;
    }

    const tipoKeys = [
      "eps", "arl", "afp", "ces", "ccf", "bancos", "transporte", "colegio",
      "cda", "taller", "eds", "contratista", "proveedor", "aseguradora",
      "almacen", "serviteca"
    ];
    const datosEmpresas = { ...datos };

    tipoKeys.forEach((k) => datosEmpresas[k] = datosEmpresas[k] ? 1 : 0);
    if (!tipoKeys.some((k) => datosEmpresas[k] === 1)) {
      return this.mostrarAlerta("Tipo requerido", "Selecciona al menos un tipo de empresa.", "info");
    }

    datos.estado = 1;

    this.empresasService.createEmpresa(datos).subscribe({
      next: (empresaCreada) => {
        modalRef.close();

        this.empresasService.getEmpresasCDA().subscribe({
          next: (cdaEmpresas) => {
            this.listaCDA = cdaEmpresas;
            this.formNuevo.get('nitEmpresa')?.setValue(empresaCreada.nit);
          },
          error: (err) => console.error('Error al cargar empresas actualizadas:', err)
        });

        this.mostrarAlerta("Éxito", "Empresa registrada correctamente", "success");
      },
      error: () => this.mostrarAlerta("Error", "No se pudo registrar la empresa", "error")
    });
  }

  trackByNit(index: number, item: any): any {
    return item.nit;
  }

  mostrarAlerta(titulo: string, mensaje: string, icono: "success" | "error" | "info") {
    Swal.fire({
      icon: icono,
      title: titulo,
      text: mensaje,
      confirmButtonText: "Aceptar"
    });
  }

  openModalClase(content: any, clase?: any): void {
    if (clase) {
      this.editMode = true;
      this.claseselecionada = clase;
      this.formClase.patchValue(clase); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formClase.reset(); // Limpia el formulario para un nuevo registro
    }

    this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });
  }

  guardarClase(): void {
    if (this.formClase.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }

    const datosClase = this.formClase.value;
    this.tiposService.createTipo(datosClase).subscribe({
      next: () => {
        Swal.fire({
          icon: "success",
          title: "Guardado exitoso",
          text: " creada correctamente.",
        });
        this.formClase.reset();
        this.modalService.dismissAll(); // Cierra el modal
      },
      error: (err) => {
        Swal.fire({
          icon: "error",
          title: "Error al guardar",
          text: err.error?.message || "Ocurrió un error inesperado.",
        });
      },
    });
  }

  cerrarModal(): void {
    // Mover el foco a un elemento visible antes de cerrar el modal
    const elementoDestino = document.getElementById("elementoDestino"); // Por ejemplo, el botón que abre el modal
    if (elementoDestino) {
      elementoDestino.focus();
    }
    this.modalService.dismissAll();
  }

  ValidarDocumentosPorId(id: number) {
    this.tiposerviciodocumentoService.getTiposervicioDocumentoById(id).subscribe(
      (servicio) => {
        if (Array.isArray(servicio)) {
          this.validarTO = servicio.some((item) => item.documento?.sigla === "TO");
          this.validarBIM = servicio.some((item) => item.documento?.sigla === "BIM");
          this.validarLT = servicio.some((item) => item.documento?.sigla === "LT");
          this.validarRCC = servicio.some((item) => item.documento?.sigla === "RCC");
          this.validarRCE = servicio.some((item) => item.documento?.sigla === "RCE");
          this.validarSOAT = servicio.some((item) => item.documento?.sigla === "SOAT");
          this.validarCDA = servicio.some((item) => item.documento?.sigla === "CDA");
          this.validarPTR = servicio.some((item) => item.documento?.sigla === "PTR");
        } else {
          this.resetValidadores();
        }
      },
      (error) => {
        console.error("Error obteniendo el servicio:", error);
        this.resetValidadores();
      }
    );
  }

  resetValidadores(): void {
    this.validarTO = false;
    this.validarBIM = false;
    this.validarLT = false;
    this.validarRCC = false;
    this.validarRCE = false;
    this.validarSOAT = false;
    this.validarCDA = false;
    this.validarPTR = false;
  }

  listarTarjetaOperaciones(placa: string): void {
    this.tarjetaoperacionesService.getTarjetasPlaca(placa).subscribe({
      next: (data) => {
       // console.log('Tarjetas de operación cargadas:', data);
        this.tarjetaOperacion = data;
        if (this.tarjetaOperacion.length === 0) {
          console.warn('🚫 No se encontraron tarjetas para la placa:', placa);
        }
      },
      error: (err) => {
        console.error("❌ Error cargando tarjetas de operación:", err);
      },
    });
  }
  // Método auxiliar para reiniciar las validaciones
  puedeEditar(tarjeta: any): boolean {
    // Convertimos el estado a minúsculas para evitar problemas de mayúsculas/minúsculas
    const estadoTexto = tarjeta?.estado_fechas
      ? String(tarjeta.estado_fechas).trim().toLowerCase()
      : "";

    return estadoTexto === "vigente";
  }

  openModalTarjetaOperacion(content: any, id?: number) {
 //   console.log('Abriendo modal de tarjeta de operación... ID:', id);
    if (id) {
      // Modo edición
      this.tarjetaoperacionesService
        .getTarjetaByNumero(id)
        .subscribe({
          next: (tarjeta) => {
            this.editMode = true;               // <-- aquí activas el modo edición
            this.tarjetaSeleccionada = tarjeta;
            this.formTarjeta.patchValue(tarjeta);
            this.modalService.open(content, { size: "xl", backdrop: "static" });
          },
          error: () => {
            Swal.fire({
              icon: "error",
              title: "No encontrada",
              text: `No se encontró una tarjeta con el número ${id}.`,
            });
          },
        });
    } else {
      // Modo creación
   //   console.log('Abriendo modal en modo creación de tarjeta de operación');
      this.editMode = false;                  // <-- aquí desactivas el modo edición
      this.tarjetaSeleccionada = null;
      this.formTarjeta.reset();
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }

  guardarTarjetaOperacion() { 
  //  console.log('Guardando tarjeta de operación... modo:', this.editMode ? 'edición' : 'creación');

    if (this.formTarjeta.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }

    // Validaciones de campos requeridos
    if (!this.formTarjeta.get('numero_tarjeta')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un número", "info");
      this.inputTarjeta?.nativeElement.focus();
      return;
    }

    if (!this.formTarjeta.get('fecha_expedicion')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una fecha de expedición", "info");
      this.inputFechaExpedicionTarjeta?.nativeElement.focus();
      return;
    }

    if (!this.formTarjeta.get('fecha_vencimiento')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una fecha de vencimiento", "info");
      this.inputFechaVencimientoTarjeta?.nativeElement.focus();
      return;
    }

    const datosTarjetaOperacion = this.formTarjeta.value;
    const placa = this.vehicle?.placa;

    if (!placa) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "La placa del vehículo no está disponible.",
      });
      return;
    }

    datosTarjetaOperacion.placa = placa;
    datosTarjetaOperacion.usuario_creacion = "admin";

    // MODO EDICIÓN
    if (this.editMode && this.tarjetaSeleccionada) {
     // console.log('Tarjeta seleccionada:', this.tarjetaSeleccionada);
      
      // Comparar si hay cambios
      const datosSinCambios =
        JSON.stringify(this.tarjetaSeleccionada) ===
        JSON.stringify(datosTarjetaOperacion);

      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones en la tarjeta de operación.",
        });
        return;
      }

     // console.log('Datos modificados, procediendo a actualizar...');
      this.tarjetaoperacionesService
        .updateTarjeta(this.tarjetaSeleccionada.id, datosTarjetaOperacion)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "Tarjeta de operación actualizada correctamente.",
            });
            this.cerrarModalYRecargar(placa);
          },
          error: (err) => {
            this.mostrarError(err, "Error al actualizar la tarjeta");
          },
        });
    } else {
      // MODO CREACIÓN
     // console.log('Creando nueva tarjeta de operación...');
      this.tarjetaoperacionesService
        .createTarjeta(datosTarjetaOperacion)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Guardado exitoso",
              text: "Tarjeta de operación creada correctamente.",
            });
            this.formTarjeta.reset();
            this.cerrarModalYRecargar(placa);
          },
          error: (err) => {
            this.mostrarError(err, "Error al guardar la tarjeta");
          },
        });
    }
  }

  private cerrarModalYRecargar(placa: string) {
    this.modalService.dismissAll(); // Cierra el modal
    this.listarTarjetaOperaciones(placa); // Recarga las tarjetas para la placa actual
  }

  private mostrarError(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  estadoMap: { [key: string]: string } = {
    VIGENTE: "badge badge-light-success", // Verde
    PORVENCER: "badge badge-light-warning", // Amarillo
    VENCIDO: "badge badge-light-secondary", // Rojo
  };

  // Función que devuelve la clase correspondiente al estado de la fecha
  getEstadoColor(estado: string | undefined): string {
    return this.estadoMap[estado || ""] || "badge badge-light-primary"; // Si no hay estado, por defecto aplica "Vencido"
  }

  actualizarEstadoAInactivo(numero_tarjeta: string) {
    // Confirmación de la acción de inactivar
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar la tarjeta de operación con el número de tarjeta: ${numero_tarjeta}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Llamada al servicio para actualizar el estado de la tarjeta a 0
        this.tarjetaoperacionesService
          .updateEstadoToCero(numero_tarjeta)
          .subscribe({
            next: (response) => {
              // Mensaje de éxito
              Swal.fire({
                icon: "success",
                title: "¡Éxito!",
                text: "El estado de la tarjeta ha sido actualizado.",
                confirmButtonText: "Aceptar",
              });

              // Actualizar la tarjeta localmente cambiando el estado a 0
              const tarjetaIndex = this.tarjetaOperacion.findIndex(
                (tarjeta) => tarjeta.numero_tarjeta === numero_tarjeta
              );
              if (tarjetaIndex !== -1) {
                this.tarjetaOperacion[tarjetaIndex].estado = 0; // Aquí asumiendo que "estado" es el campo que quieres actualizar
              }

              // Volver a llamar a listarTarjetaOperaciones para refrescar la tabla con las tarjetas actualizadas
              this.listarTarjetaOperaciones(
                this.tarjetaOperacion[tarjetaIndex].placa
              );
            },
            error: (error) => {

              // Asegurarse de que el error tenga un objeto "error" válido
              const errorBody = error?.error || {}; // Si no tiene "error", usamos un objeto vacío
              const errorMessage =
                errorBody?.message ||
                "No se pudo actualizar el estado de la tarjeta"; // Usamos un mensaje predeterminado si no existe

              // Mostrar el mensaje de error
              Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMessage,
                confirmButtonText: "Aceptar",
              });
            },
          });
      }
    });
  }

  validarPlaca(event: any) {
    let valor = event.target.value;
    event.target.value = valor.replace(/[^A-Za-z0-9]/g, "").slice(0, 6);
    this.formNuevo.controls["placa"].setValue(event.target.value, {
      emitEvent: false,
    });
  }

  listarSoats(placa: string): void {
    this.soatList = []; // Limpiar la lista antes de actualizar

    this.historialSoatService.getByPlaca(placa).subscribe({
      next: (response) => {
        this.soatList = response;

      },
      error: (err) => console.error("❌ Error cargando SOATs:", err),
    });
  }

  puedeEditarSoat(soat: any): boolean {
    const estadoTexto = soat?.estadoCalculado.estado
      ? String(soat.estadoCalculado.estado).trim().toLowerCase()
      : "";
    return estadoTexto === "vigente";
  }

  openModalSoat(content: any, id?: number) {
    if (id) {
      // Si se proporciona un ID, realiza la solicitud para obtener el SOAT por ID
      this.historialSoatService.getById(id).subscribe({
        next: (soat) => {
          this.soatSeleccionado = soat;
          this.editMode = true; // Modo edición activado
          this.formSoat.patchValue(soat); // Llena el formulario con los datos del SOAT
          this.modalService.open(content, { size: "xl", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrado",
            text: `No se encontró un SOAT con el número ${id}.`,
          });
        },
      });
    } else {
      // Si no se pasa un ID, solo abre el modal con el formulario vacío
      this.editMode = false; // Modo creación activado
      this.formSoat.reset();
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }

  guardarSoat() {
    // Validar formulario general
    if (this.formSoat.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }

    // Obtener datos y asegurar placa
    let datosSoat = this.formSoat.value;
    datosSoat.placa = datosSoat.placa || this.placaSeleccionada;

    if (!datosSoat.placa) {
      Swal.fire({
        icon: "error",
        title: "Placa faltante",
        text: "No se ha detectado la placa del vehículo.",
      });
      return;
    }

    // Validaciones de campos específicos
    const camposRequeridos = [
      { campo: 'aseguradora', mensaje: 'Seleccione una aseguradora', input: this.inputAseguradoraSoat },
      { campo: 'id_soat', mensaje: 'Ingresa un número', input: this.inputNumeroSoat },
      { campo: 'fecha_soat', mensaje: 'Ingresa una fecha de expedición', input: this.inputFechaExpedicionSoat },
      { campo: 'vencimiento_soat', mensaje: 'Ingresa una fecha de vencimiento', input: this.inputFechaVencimientoSoat },
      { campo: 'valor', mensaje: 'Ingresa un valor', input: this.inputValorSoat },
      { campo: 'tarifa', mensaje: 'Ingresa una tarifa', input: this.inputTarifaSoat },
    ];

    for (let campo of camposRequeridos) {
      if (!this.formSoat.get(campo.campo)?.value) {
        this.mostrarAlerta("Campo requerido", `Por favor, ${campo.mensaje}`, "info");
        campo.input?.nativeElement.focus();
        return;
      }
    }

    // Si es edición
    if (this.editMode && this.soatSeleccionado) {
      const datosSinCambios = JSON.stringify(this.soatSeleccionado) === JSON.stringify(datosSoat);
      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones en el SOAT.",
        });
        return;
      }

      this.historialSoatService.update(this.soatSeleccionado.id, datosSoat).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "SOAT actualizado correctamente.",
          });
          this.cerrarModalYRecargar3(datosSoat.placa);
        },
        error: (err) => this.mostrarError3(err, "Error al actualizar el SOAT"),
      });
    } else {
      // Crear nuevo
      this.historialSoatService.create(datosSoat).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Guardado exitoso",
            text: "SOAT creado correctamente.",
          });
          this.formSoat.reset();
          this.cerrarModalYRecargar3(datosSoat.placa);
        },
        error: (err) => this.mostrarError3(err, "Error al guardar el SOAT"),
      });
    }
  }

  private cerrarModalYRecargar3(placa: string) {
    this.modalService.dismissAll();
    // Limpiar la lista antes de recargar
    this.soatList = [];
    this.listarSoats(placa); // Recargar los SOATs con la placa actualizada
  }

  private mostrarError3(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  actualizarEstadoAInactivoSoat(id_soat: number) {
    Swal.fire({
      title: "INACTIVAR SOAT",
      text: `¿Desea inactivar el SOAT con el número: ${id_soat}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.historialSoatService.inactivarSoat(id_soat).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "¡Éxito!",
            text: "El estado del SOAT ha sido actualizado.",
          });

          // Buscar la placa asociada al SOAT inactivado
          let placa = this.placaSeleccionada;
          const soatIndex = this.soatList.findIndex(soat => soat.id_soat === id_soat);
          if (soatIndex !== -1 && this.soatList[soatIndex].placa) {
            this.soatList[soatIndex].estado = 0;
            placa = this.soatList[soatIndex].placa;
          }
          if (placa) {
            this.listarSoats(placa);
          }
        },
        error: (error) => {
          const mensaje =
            error?.error?.message || "No se pudo actualizar el estado del SOAT";
          Swal.fire({
            icon: "error",
            title: "Error",
            text: mensaje,
          });
          // Refrescar la lista aunque haya error, por si el backend sí cambió el estado
          let placa = this.placaSeleccionada;
          const soatIndex = this.soatList.findIndex(soat => soat.id_soat === id_soat);
          if (soatIndex !== -1 && this.soatList[soatIndex].placa) {
            placa = this.soatList[soatIndex].placa;
          }
          if (placa) {
            this.listarSoats(placa);
          }
        },
      });
    });
  }

  listarCda(placa: string): void {
    this.historialCda = []; // Limpiar datos viejos

    this.historialCdaService.getByPlaca(placa).subscribe({
      next: (response) => {
        this.historialCda = response;
      },
      error: (err) => console.error("❌ Error cargando CDA:", err),
    });
  }

  puedeEditarCda(cda: any): boolean {
    const estadoTexto = cda?.estadoCalculado.estado
      ? String(cda.estadoCalculado.estado).trim().toLowerCase()
      : "";
    return estadoTexto === "vigente";
  }

  openModalCda(content: any, id?: number) {
    if (id) {
      this.historialCdaService.getById(id).subscribe({
        next: (cda) => {
         // console.log('CDA obtenido para edición:', cda);
          this.cdaSelecionado = cda;
          this.formCda.patchValue(cda);
          this.editMode = true; // Modo edición activado
          this.modalService.open(content, { size: "xl", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrado",
            text: `No se encontró un CDA con el número ${id}.`,
          });
        },
      });
    } else {
      this.editMode = false; // Modo creación activado
      this.formCda.reset();
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }

  guardarCda() {
    if (this.formCda.invalid) {
      return Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
    }

    // Validaciones específicas
    const camposRequeridos = [
      { nombre: 'idcda', mensaje: 'Ingrese un número de certificado', ref: this.inputCertificadoCda },
      { nombre: 'centrocda', mensaje: 'Seleccione un centro de CDA', ref: this.inputCentroCda },
      { nombre: 'fechacda', mensaje: 'Seleccione una fecha de expedición', ref: this.inputFechaExpedicionCda },
      { nombre: 'vcda', mensaje: 'Seleccione una fecha de vencimiento', ref: this.inputFechaVencimientoCda },
    ];

    for (const campo of camposRequeridos) {
      const valor = this.formCda.get(campo.nombre)?.value;
      if (!valor) {
        this.mostrarAlerta("Campo requerido", `Por favor, ${campo.mensaje}`, "info");

        setTimeout(() => campo.ref?.nativeElement?.focus(), 0);
        return;
      }
    }

    // Preparamos los datos
    const datosCda = {
      ...this.formCda.value,
      placa: this.formCda.value.placa || this.placaSeleccionada
    };

    if (!datosCda.placa) {
      return Swal.fire({
        icon: "error",
        title: "Placa faltante",
        text: "No se ha detectado la placa del vehículo.",
      });
    }

    // Modo edición
    if (this.editMode && this.cdaSelecionado) {
      const sinCambios = JSON.stringify(this.cdaSelecionado) === JSON.stringify(datosCda);
      if (sinCambios) {
        return Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones en el CDA.",
        });
      }

      this.historialCdaService.update(this.cdaSelecionado.id, datosCda).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "RTM actualizado correctamente.",
          });
          this.cerrarModalYRecargar4(datosCda.placa);
        },
        error: (err) => this.mostrarError4(err, "Error al actualizar el RMT"),
      });

    } else {
      // Modo creación
      this.historialCdaService.create(datosCda).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Renovación exitosa",
            text: "RMT renovado correctamente.",
          });
          this.formCda.reset();
          this.cerrarModalYRecargar4(datosCda.placa);
        },
        error: (err) => this.mostrarError4(err, "Error al guardar el RMT"),
      });
    }
  }


  actualizarEstadoAInactivoCda(idcda: number) {
    Swal.fire({
      title: "INACTIVAR CDA",
      text: `¿Desea inactivar el CDA con número: ${idcda}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.historialCdaService.softDeleteById(idcda).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "¡Éxito!",
            text: "El estado del CDA ha sido actualizado.",
          });

          // Buscar el CDA en el historial y obtener su placa
          const cdaIndex = this.historialCda.findIndex(
            (cda) => cda.idcda === idcda
          );
          
          if (cdaIndex !== -1) {
            this.historialCda[cdaIndex].estado = 0;
            const placa = this.historialCda[cdaIndex].placa;
            
            // Recargar solo si tenemos una placa válida
            if (placa) {
              this.listarCda(placa);
            }
          } else {
            // Si no se encuentra en el array local, usar la placa seleccionada
            if (this.placaSeleccionada) {
              this.listarCda(this.placaSeleccionada);
            }
          }
        },
        error: (error) => {
          const errorMessage =
            error?.error?.message ||
            "No se pudo actualizar el estado del CDA";
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage,
          });
        },
      });
    });
  }

  private cerrarModalYRecargar4(placa: string) {
    this.modalService.dismissAll();
    this.historialCda = []; // Limpiar datos viejos
    this.listarCda(placa); // Recargar lista
  }

  private mostrarError4(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  listarExtintor(placa: string): void {
    this.historialExtintor = [];

    this.historialExtintorService.getByPlaca(placa).subscribe({
      next: (response) => {
        this.historialExtintor = response;

      }
    });
  }

  estadoMap2: { [key: string]: string } = {
    Vigente: "badge badge-light-success", // Verde
    "Por vencer": "badge badge-light-warning", // Amarillo
    Vencido: "badge badge-light-secondary", // Rojo
  };

  // Función que devuelve la clase correspondiente al estado de la fecha
  getEstadoColor2(estado: string | undefined): string {
    return this.estadoMap2[estado || ""] || "badge badge-light-primary";
  }

  puedeEditarExtintor(extintor: any): boolean {
    const estadoTexto = extintor?.estadoCalculado.estado
      ? String(extintor.estadoCalculado.estado).trim().toLowerCase()
      : "";
    return estadoTexto === "vigente";
  }

  openModalExtintor(content: any, id?: number) {
    if (id) {
      this.historialExtintorService.getByIdExtintor(id).subscribe({
        next: (extintor) => {
          this.extintorSeleccionado = extintor;
          this.formExtintor.patchValue(extintor);
          this.editMode = true;
          this.modalService.open(content, { size: "xl", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrado",
            text: `No se encontró un registro de extintor con número ${id}.`,
          });
        },
      });
    } else {
      this.editMode = false;
      this.formExtintor.reset();
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }

  guardarExtintor() {
    if (this.formExtintor.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }


    const camposRequeridos = [
      { campo: 'idextintor', mensaje: 'Ingrese el id del extintor', input: this.inputIdExtintor },
      { campo: 'frecarga', mensaje: 'Ingrese la fecha de recarga', input: this.inputFreCargaExtintor },
      { campo: 'vrecarga', mensaje: 'Ingrese una fecha de vencimiento', input: this.inputVencimientoExtintor }
    ];

    for (let campo of camposRequeridos) {
      if (!this.formExtintor.get(campo.campo)?.value) {
        this.mostrarAlerta("Campo requerido", `Por favor, ${campo.mensaje}`, "info");

        const inputElement = campo.input?.nativeElement;
        if (inputElement) {
          setTimeout(() => {
            inputElement.focus();
            inputElement.select(); // selecciona el contenido si aplica
          }, 0);
        }

        return;
      }
    }


    let datosExtintor = this.formExtintor.value;
    datosExtintor.placa = datosExtintor.placa || this.placaSeleccionada;

    if (!datosExtintor.placa) {
      Swal.fire({
        icon: "error",
        title: "Placa faltante",
        text: "No se ha detectado la placa del vehículo.",
      });
      return;
    }

    if (this.editMode && this.extintorSeleccionado) {
      const datosSinCambios =
        JSON.stringify(this.extintorSeleccionado) ===
        JSON.stringify(datosExtintor);
      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones en el extintor.",
        });
        return;
      }

      this.historialExtintorService
        .update(this.extintorSeleccionado.id, datosExtintor)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "Extintor actualizado correctamente.",
            });
            this.cerrarModalYRecargarExtintor(datosExtintor.placa);
          },
          error: (err) =>
            this.mostrarErrorExtintor(err, "Error al actualizar el extintor"),
        });
    } else {
      this.historialExtintorService.create(datosExtintor).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Guardado exitoso",
            text: "Extintor creado correctamente.",
          });
          this.formExtintor.reset();
          this.cerrarModalYRecargarExtintor(datosExtintor.placa);
        },
        error: (err) =>
          this.mostrarErrorExtintor(err, "Error al guardar el extintor"),
      });
    }
  }

  actualizarEstadoAInactivoExtintor(idextintor: string) {
    Swal.fire({
      title: "INACTIVAR EXTINTOR",
      text: `¿Desea inactivar el extintor con número: ${idextintor}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.historialExtintorService
          .inactivarPorIdExtintor(Number(idextintor))
          .subscribe({
            next: () => {
              Swal.fire({
                icon: "success",
                title: "¡Éxito!",
                text: "El estado del extintor ha sido actualizado.",
              });

              const index = this.historialExtintor.findIndex(
                (ext) => ext.idextintor === idextintor
              );
              if (index !== -1) {
                this.historialExtintor[index].estado = 0;
              }

              this.listarExtintor(this.historialExtintor[index]?.placa);
            },
            error: (error) => {
              const errorMessage =
                error?.error?.message ||
                "No se pudo actualizar el estado del extintor";
              Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMessage,
              });
            },
          });
      }
    });
  }

  private cerrarModalYRecargarExtintor(placa: string) {
    this.modalService.dismissAll();
    this.historialExtintor = [];
    this.listarExtintor(placa);
  }

  private mostrarErrorExtintor(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  listarBimestral(placa: string): void {
    this.historialBimestral = [];

    this.historialBimestralService.getByPlaca(placa).subscribe({
      next: (response) => {
        this.historialBimestral = response;


      },
      error: (err) =>
        console.error("❌ Error cargando revisiones bimestrales:", err),
    });
  }

  estadoMapBimestral: { [key: string]: string } = {
    Vigente: "badge badge-light-success",
    "Por vencer": "badge badge-light-warning",
    Vencido: "badge badge-light-secondary",
  };

  getEstadoColorBimestral(estado: string | undefined): string {
    return this.estadoMapBimestral[estado || ""] || "badge badge-light-primary";
  }

  puedeEditarBimestral(centro_diagnostico: any): boolean {
    const estadoTexto = centro_diagnostico?.estadoCalculado.estado
      ? String(centro_diagnostico.estadoCalculado.estado).trim().toLowerCase()
      : "";
    return estadoTexto === "vigente";
  }

  openModalBimestral(content: any, id?: number) {
    if (id) {
      this.historialBimestralService.getById(id).subscribe({
        next: (bimestral: any) => {
        //  console.log('Bimestral obtenido para edición:', bimestral);
       //   console.log('Empresas CDA disponibles:', this.empresascda);
          
          this.bimestralSeleccionado = bimestral;
          this.placaSeleccionada = bimestral.placa;
          
          // Extraer el valor del centro de diagnóstico
          const centroDiagnostico = bimestral.centroDiagnostico || bimestral.centro_diagnostico;
        //  console.log('Centro diagnóstico del API:', centroDiagnostico);
          
          // Verificar si existe en la lista de empresas CDA
          const cdaExiste = this.empresascda?.find((cda: any) => cda.nit === centroDiagnostico);
        //  console.log('CDA encontrado en lista:', cdaExiste);
          
          // Mapear propiedades del API (camelCase) al formulario (snake_case)
          const formData = {
            centro_diagnostico: centroDiagnostico,
            revision_aprobada: String(bimestral.revisionAprobada || bimestral.revision_aprobada || ''),
            ultima_revision: bimestral.ultimaRevision || bimestral.ultima_revision,
            proxima_revision: bimestral.proximaRevision || bimestral.proxima_revision,
            placa: bimestral.placa
          };
          
         // console.log('Datos a asignar al formulario:', formData);
          this.formBimestral.patchValue(formData);
          
          // Forzar actualización del ng-select con un setTimeout
          setTimeout(() => {
            this.formBimestral.patchValue({ centro_diagnostico: centroDiagnostico });
            // console.log('Valor final del formulario:', this.formBimestral.value);
          }, 100);
          
          this.editMode = true;
          this.modalService.open(content, { size: "xl", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrado",
            text: `No se encontró un registro de revisión bimestral con ID ${id}.`,
          });
        },
      });
    } else {
      console.log('Abriendo modal en modo creación');
      this.editMode = false;
      this.bimestralSeleccionado = null;
      this.formBimestral.reset();
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }

  guardarBimestral() {
    if (this.formBimestral.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }


    const camposRequeridos = [
      { campo: 'centro_diagnostico', mensaje: 'Ingrese el Centro de diagnostico', input: this.inputCentroDiagnosticoBim },
      { campo: 'revision_aprobada', mensaje: 'Seleccione una revisión', input: this.inputRevisionBim },
      { campo: 'ultima_revision', mensaje: 'Ingrese una fecha de la ultima revisión', input: this.inputUltimaRevisionBim },
      { campo: 'proxima_revision', mensaje: 'Ingrese una fecha de la proxima revisión', input: this.inputProximaRevisionBim }
    ];

    for (let campo of camposRequeridos) {
      if (!this.formBimestral.get(campo.campo)?.value) {
        this.mostrarAlerta("Campo requerido", `Por favor, ${campo.mensaje}`, "info");

        const inputElement = campo.input?.nativeElement;
        if (inputElement) {
          setTimeout(() => {
            inputElement.focus();
            inputElement.select(); // selecciona el contenido si aplica
          }, 0);
        }

        return;
      }
    }


    let datos = this.formBimestral.value;

    // Asegurar que se asigne la placa si no viene del form
    datos.placa = datos.placa || this.placaSeleccionada;
    datos.centro_diagnostico = datos.centro_diagnostico || this.centroDiagnosticoSeleccionado;

    if (!datos.placa) {
      Swal.fire({
        icon: "error",
        title: "Placa faltante",
        text: "No se ha detectado la placa del vehículo.",
      });
      return;
    }

    if (!datos.centro_diagnostico) {
      Swal.fire({
        icon: "error",
        title: "Centro de diagnóstico faltante",
        text: "No se ha detectado el centro de diagnóstico.",
      });
      return;
    }

    // MODO EDICIÓN
    if (this.editMode && this.bimestralSeleccionado) {
      console.log('Modo edición - Datos a actualizar:', datos);
      console.log('Datos originales:', this.bimestralSeleccionado);
      
      const datosSinCambios =
        JSON.stringify(this.bimestralSeleccionado) === JSON.stringify(datos);
      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones.",
        });
        return;
      }

      this.historialBimestralService.update(this.bimestralSeleccionado.id, datos).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "Revisión actualizada correctamente.",
          });
          this.cerrarModalYRecargarBimestral(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorBimestral(err, "Error al actualizar la revisión"),
      });
    } else {
      // MODO CREACIÓN
      console.log('Modo creación - Datos a crear:', datos);
      this.historialBimestralService.create(datos).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Guardado exitoso",
            text: "Revisión creada correctamente.",
          });
          this.formBimestral.reset();
          this.cerrarModalYRecargarBimestral(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorBimestral(err, "Error al guardar la revisión"),
      });
    }
  }

  actualizarEstadoAInactivoBimestral(id: number) {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar esta revisión bimestral?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.historialBimestralService.inactivarPorId(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "¡Éxito!",
              text: "La revisión fue inactivada correctamente.",
            });

            // 🔁 Refrescar tabla
            this.listarBimestral(this.placaSeleccionada);
          },
          error: (error) => {
            const errorMessage = error?.error?.message || "No se pudo inactivar la revisión";
            Swal.fire({
              icon: "error",
              title: "Error",
              text: errorMessage,
            });
          },
        });
      }
    });
  }

  private cerrarModalYRecargarBimestral(centro_diagnostico: string) {
    this.modalService.dismissAll();
    this.historialBimestral = [];
    this.listarBimestral(centro_diagnostico);
  }

  private mostrarErrorBimestral(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  listarContractual(placa: string): void {
    this.historialContractual = [];

    this.historialContractualService.getByPlaca(placa).subscribe({
      next: (response) => {
        this.historialContractual = response;
      },
      error: (err) =>
        console.error("❌ Error cargando historial contractual:", err),
    });
  }

  estadoMapContractual: { [key: string]: string } = {
    Vigente: "badge badge-light-success",
    "Por vencer": "badge badge-light-warning",
    Vencido: "badge badge-light-secondary",
  };

  getEstadoColorContractual(estado: string | undefined): string {
    return this.estadoMapContractual[estado || ""] || "badge badge-light-primary";
  }

  openModalContractual(content: any, id?: number) {
    if (id) {
      this.historialContractualService.getById(id).subscribe({
        next: (contractual) => {
          this.contractualSeleccionado = contractual;
          this.formContractual.patchValue(contractual);
          this.placaSeleccionada = contractual.placa;
          this.editMode = true;
          this.modalService.open(content, { size: "xl", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrado",
            text: `No se encontró un historial contractual con ID ${id}.`,
          });
        },
      });
    } else {
      this.editMode = false;
      this.formContractual.reset();
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }

  guardarContractual() {
    if (this.formContractual.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }


    const camposRequeridos = [
      { campo: 'aseguradoraRCC', mensaje: 'Seleccione una aseguradora', input: this.inputAseguradoraCont },
      { campo: 'intermediariaRCC', mensaje: 'Ingrese una intermediaria', input: this.inputIntermediaCont },
      { campo: 'fecha_expedicionRCC', mensaje: 'Ingrese una fecha de expedición', input: this.inputFechaExpedicionCont },
      { campo: 'fecha_vencimientoRCC', mensaje: 'Ingrese una fecha de vencimiento', input: this.inputFechaVencimientoCont },
      { campo: 'numeroRCC', mensaje: 'Ingrese un numero contractual', input: this.inputNumeroCont },
    ];

    for (let campo of camposRequeridos) {
      if (!this.formContractual.get(campo.campo)?.value) {
        this.mostrarAlerta("Campo requerido", `Por favor, ${campo.mensaje}`, "info");

        const inputElement = campo.input?.nativeElement;
        if (inputElement) {
          setTimeout(() => {
            inputElement.focus();
            inputElement.select(); // selecciona el contenido si aplica
          }, 0);
        }

        return;
      }
    }


    let datos = this.formContractual.value;
    datos.placa = datos.placa || this.placaSeleccionada;

    if (!datos.placa) {
      Swal.fire({
        icon: "error",
        title: "Placa faltante",
        text: "No se ha detectado la placa del vehículo.",
      });
      return;
    }

    if (this.editMode && this.contractualSeleccionado) {
      const datosSinCambios =
        JSON.stringify(this.contractualSeleccionado) === JSON.stringify(datos);
      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones.",
        });
        return;
      }

      this.historialContractualService.update(this.contractualSeleccionado.id, datos).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "Historial contractual actualizado correctamente.",
          });
          this.cerrarModalYRecargarContractual(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorContractual(err, "Error al actualizar el historial"),
      });
    } else {
      this.historialContractualService.create(datos).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Guardado exitoso",
            text: "Historial contractual creado correctamente.",
          });
          this.formContractual.reset();
          this.cerrarModalYRecargarContractual(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorContractual(err, "Error al guardar el historial"),
      });
    }
  }

  private cerrarModalYRecargarContractual(placa: string) {
    this.modalService.dismissAll();
       this.historialContractual = [];
    this.listarContractual(placa);
  }

  private mostrarErrorContractual(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  inactivarPorIdContractual(id: number): void {
    Swal.fire({
      icon: "question",
      title: "¿Estás seguro?",
      text: `Se inactivará el historial contractual con ID ${id}.`,
      showCancelButton: true,
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        this.historialContractualService.inactivarPorId(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Historial inactivado",
              text: `El historial con ID ${id} fue inactivado correctamente.`,
            });
            this.listarContractual(this.placaSeleccionada); // Si quieres seguir listando por placa
          },
          error: (err) =>
            this.mostrarErrorContractual(err, "Error al inactivar el historial"),
        });
      }
    });
  }

  listarExtracontractual(placa: string): void {
    this.historialExtracontractual = [];

    this.historialExtraContractualService.getAll().subscribe({
      next: (response) => {
        this.historialExtracontractual = response.historial.filter(
          (extra: HistorialExtraContractual) => extra.placa === placa
        );
        this.estadisticasExtracontractual = response
      },
      error: (err) =>
        console.error("❌ Error cargando historial extracontractual:", err),
    });
  }

  estadoMapExtracontractual: { [key: string]: string } = {
    Vigente: "badge badge-light-success",
    "Por vencer": "badge badge-light-warning",
    Vencido: "badge badge-light-secondary",
  };

  getEstadoColorExtracontractual(estado: string | undefined): string {
    return this.estadoMapExtracontractual[estado || ""] || "badge badge-light-primary";
  }

  openModalExtracontractual(content: any, id?: number) {
    if (id) {
      this.historialExtraContractualService.getById(id).subscribe({
        next: (extra) => {
          this.extraSeleccionado = extra;
          this.formExtracontractual.patchValue(extra);
          this.placaSeleccionada = extra.placa;
          this.editMode = true;
          this.modalService.open(content, { size: "xl", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrado",
            text: `No se encontró un historial extracontractual con ID ${id}.`,
          });
        },
      });
    } else {
      this.editMode = false;
      this.formExtracontractual.reset();
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }

  guardarExtracontractual() {
    if (this.formExtracontractual.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }


    const camposRequeridos = [
      { campo: 'aseguradoraRCE', mensaje: 'Seleccione una aseguradora', input: this.inputAseguradoraExt },
      { campo: 'intermediariaRCE', mensaje: 'Ingrese una intermediaria', input: this.inputIntermediaExt },
      { campo: 'fecha_expedicionRCE', mensaje: 'Ingrese una fecha de expedición', input: this.inputFechaExpedicionExt },
      { campo: 'fecha_vencimientoRCE', mensaje: 'Ingrese una fecha de vencimiento', input: this.inputFechaVencimientoExt },
      { campo: 'numeroRCE', mensaje: 'Ingrese un numero extracontractual', input: this.inputNumeroExt },
    ];

    for (let campo of camposRequeridos) {
      if (!this.formExtracontractual.get(campo.campo)?.value) {
        this.mostrarAlerta("Campo requerido", `Por favor, ${campo.mensaje}`, "info");

        const inputElement = campo.input?.nativeElement;
        if (inputElement) {
          setTimeout(() => {
            inputElement.focus();
            inputElement.select(); // selecciona el contenido si aplica
          }, 0);
        }

        return;
      }
    }

    let datos = this.formExtracontractual.value;
    datos.placa = datos.placa || this.placaSeleccionada;

    if (!datos.placa) {
      Swal.fire({
        icon: "error",
        title: "Placa faltante",
        text: "No se ha detectado la placa del vehículo.",
      });
      return;
    }

    if (this.editMode && this.extraSeleccionado) {
      const datosSinCambios =
        JSON.stringify(this.extraSeleccionado) === JSON.stringify(datos);
      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones.",
        });
        return;
      }

      this.historialExtraContractualService.update(this.extraSeleccionado.id, datos).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "Historial extracontractual actualizado correctamente.",
          });
          this.cerrarModalYRecargarExtracontractual(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorExtracontractual(err, "Error al actualizar el historial"),
      });
    } else {
      this.historialExtraContractualService.create(datos).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Guardado exitoso",
            text: "Historial extracontractual creado correctamente.",
          });
          this.formExtracontractual.reset();
          this.cerrarModalYRecargarExtracontractual(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorExtracontractual(err, "Error al guardar el historial"),
      });
    }
  }

  private cerrarModalYRecargarExtracontractual(placa: string) {
    this.modalService.dismissAll();
    this.historialExtracontractual = [];
    this.listarExtracontractual(placa);
  }

  private mostrarErrorExtracontractual(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  inactivarPorIdExtracontractual(id: number): void {
    Swal.fire({
      icon: "question",
      title: "¿Estás seguro?",
      text: `Se inactivará el historial extracontractual con ID ${id}.`,
      showCancelButton: true,
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        this.historialExtraContractualService.inactivarPorId(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Historial inactivado",
              text: `El historial con ID ${id} fue inactivado correctamente.`,
            });
            this.listarExtracontractual(this.placaSeleccionada);
          },
          error: (err) =>
            this.mostrarErrorExtracontractual(err, "Error al inactivar el historial"),
        });
      }
    });
  }

  listarTodoRiesgo(placa: string): void {
    this.historialTodoRiesgo = [];

    this.historialTodoRiesgoService.getByPlaca(placa).subscribe({
      next: (response) => {
        this.historialTodoRiesgo = response;
      },
      error: (err) =>
        console.error('❌ Error cargando historial todo riesgo:', err),
    });
  }

  estadoMapTodoRiesgo: { [key: string]: string } = {
    Vigente: 'badge badge-light-success',
    'Por vencer': 'badge badge-light-warning',
    Vencido: 'badge badge-light-secondary',
  };



  getEstadoColorTodoRiesgo(estado: string | undefined): string {
    return this.estadoMapTodoRiesgo[estado || ''] || 'badge badge-light-primary';
  }

  openModalTodoRiesgo(content: any, id?: number) {
    if (id) {
      this.historialTodoRiesgoService.getById(id).subscribe({
        next: (item) => {
          this.todoRiesgoSeleccionado = item;
          this.formTodoriesgo.patchValue(item);
          this.placaSeleccionada = item.placa;
          this.editMode = true;
          this.modalService.open(content, { size: 'xl', backdrop: 'static' });
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'No encontrado',
            text: `No se encontró un historial todo riesgo con ID ${id}.`,
          });
        },
      });
    } else {
      this.editMode = false;
      this.formTodoriesgo.reset();
      this.modalService.open(content, { size: 'xl', backdrop: 'static' });
    }
  }

  guardarTodoRiesgo() {
    if (this.formTodoriesgo.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Formulario inválido',
        text: 'Por favor, completa todos los campos correctamente.',
      });
      return;
    }

    const camposRequeridos = [
      { campo: 'aseguradoraTD', mensaje: 'Seleccione una aseguradora', input: this.inputAseguradoraTd },
      { campo: 'fecha_expedicionTD', mensaje: 'Ingrese una fecha de expedición', input: this.inputFechaExpedicionTd },
      { campo: 'fecha_vencimientoTD', mensaje: 'Ingrese una fecha de vencimiento', input: this.inputFechaVencimientoTd },
      { campo: 'numeroTD', mensaje: 'Ingrese un numero todo riesgo', input: this.inputNumeroTd },
    ];

    for (let campo of camposRequeridos) {
      if (!this.formTodoriesgo.get(campo.campo)?.value) {
        this.mostrarAlerta("Campo requerido", `Por favor, ${campo.mensaje}`, "info");

        const inputElement = campo.input?.nativeElement;
        if (inputElement) {
          setTimeout(() => {
            inputElement.focus();
            inputElement.select(); // selecciona el contenido si aplica
          }, 0);
        }

        return;
      }
    }

    let datos = this.formTodoriesgo.value;
    datos.placa = datos.placa || this.placaSeleccionada;

    if (!datos.placa) {
      Swal.fire({
        icon: 'error',
        title: 'Placa faltante',
        text: 'No se ha detectado la placa del vehículo.',
      });
      return;
    }

    if (this.editMode && this.todoRiesgoSeleccionado) {
      const sinCambios = JSON.stringify(this.todoRiesgoSeleccionado) === JSON.stringify(datos);
      if (sinCambios) {
        Swal.fire({
          icon: 'info',
          title: 'Sin cambios',
          text: 'No se han realizado modificaciones.',
        });
        return;
      }

      this.historialTodoRiesgoService.update(this.todoRiesgoSeleccionado.id, datos).subscribe({
        next: () => {
          Swal.fire({
            icon: 'success',
            title: 'Actualización exitosa',
            text: 'Historial todo riesgo actualizado correctamente.',
          });
          this.cerrarModalYRecargarTodoRiesgo(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorTodoRiesgo(err, 'Error al actualizar el historial'),
      });
    } else {
      this.historialTodoRiesgoService.create(datos).subscribe({
        next: () => {
          Swal.fire({
            icon: 'success',
            title: 'Guardado exitoso',
            text: 'Historial todo riesgo creado correctamente.',
          });
          this.formTodoriesgo.reset();
          this.cerrarModalYRecargarTodoRiesgo(datos.placa);
        },
        error: (err) =>
          this.mostrarErrorTodoRiesgo(err, 'Error al guardar el historial'),
      });
    }
  }

  private cerrarModalYRecargarTodoRiesgo(placa: string) {
    this.modalService.dismissAll();
    this.historialTodoRiesgo = [];
    this.listarTodoRiesgo(placa);
  }

  private mostrarErrorTodoRiesgo(err: any, titulo: string) {
    Swal.fire({
      icon: 'error',
      title: titulo,
      text: err.error?.message || 'Ocurrió un error inesperado.',
    });
  }

  inactivarPorIdTodoRiesgo(id: number): void {
    Swal.fire({
      icon: 'question',
      title: '¿Estás seguro?',
      text: `Se inactivará el historial todo riesgo con ID ${id}.`,
      showCancelButton: true,
      confirmButtonText: 'Sí, inactivar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.historialTodoRiesgoService.inactivarPorId(id).subscribe({
          next: () => {
            Swal.fire({
              icon: 'success',
              title: 'Historial inactivado',
              text: `El historial con ID ${id} fue inactivado correctamente.`,
            });
            this.listarTodoRiesgo(this.placaSeleccionada);
          },
          error: (err) =>
            this.mostrarErrorTodoRiesgo(err, 'Error al inactivar el historial'),
        });
      }
    });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

private createFormNuevo(): FormGroup {
  return this.fb.group({
    servicio: ['', Validators.required],
    placa: ['', Validators.required],
    interno: ['', Validators.required],
     afiliacion: [this.getTodayDate(), Validators.required], // ✅ Fecha actual - validación con delay
    registro: [null],
    nitEmpresa: ['', Validators.required],
    estado: ['1'],
    clase: ['', Validators.required],
    marca: ['', Validators.required],
    modelo: ['', Validators.required],
    relacion: ['', Validators.required],
    Idpropietario: [''],
    sucursal: [''],
    convenio: [null],
    password: [''],
    matricula: [null],
    organismo: [''],
    fechalict: [null],
    linea: [''],
    cilindraje: [null],
    motor: [''],
    titular: [''],
    capacidad: [null],
    color: [''],
    serie: [''],
    chasis: [''],
    vin: [''],
    carroceria: [''],
    combustible: [''],
    observaciones: [''],
    kilometraje: [0, [Validators.required, Validators.min(0)]],

    // ✅ Aquí adentro sí va el grupo anidado
    conductor: this.fb.group({
      conductor_id: ['']
    })
  });
}

  private createFormTarjeta(): FormGroup {
    return this.fb.group({
      placa: [''],
      numero_tarjeta: ['', [Validators.pattern('^[0-9]+$')]],
      fecha_expedicion: [''],
      fecha_vencimiento: [''],
      usuario_creacion: ['admin'],
    });
  }

  private createFormSoat(): FormGroup {
    return this.fb.group({
      placa: [''],
      id_soat: [''],
      fecha_soat: [''],
      vencimiento_soat: [''],
      aseguradora: [''],
      valor: [''],
      tarifa: [''],
      estado: 1
    });
  }

  private createFormCda(): FormGroup {
    return this.fb.group({
      placa: [''],
      idcda: [''],
      centrocda: [''],
      fechacda: [''],
      vcda: [''],
      estado: 1
    });
  }

  private createFormExtintor(): FormGroup {
    return this.fb.group({
      placa: [''],
      idextintor: [''],
      frecarga: [''],
      vrecarga: [''],
    });
  }

  private createFormBimestral(): FormGroup {
    return this.fb.group({
      placa: [''],
      centro_diagnostico: [''],
      revision_aprobada: [''],
      ultima_revision: [''],
      proxima_revision: [''],
      estado: 1
    });
  }

  private createFormContractual(): FormGroup {
    return this.fb.group({
      placa: [''],
      aseguradoraRCC: [''],
      intermediariaRCC: [''],
      fecha_expedicionRCC: [''],
      fecha_vencimientoRCC: [''],
      numeroRCC: [''],
      estado: 1
    });
  }

  private createFormExtracontractual(): FormGroup {
    return this.fb.group({
      placa: [''],
      aseguradoraRCE: [''],
      intermediariaRCE: [''],
      fecha_expedicionRCE: [''],
      fecha_vencimientoRCE: [''],
      numeroRCE: [''],
      estado: 1
    });
  }

  private createFormTodoriesgo(): FormGroup {
    return this.fb.group({
      placa: [''],
      aseguradoraTD: [''],
      intermediariaTD: [''],
      fecha_expedicionTD: [''],
      fecha_vencimientoTD: [''],
      numeroTD: [''],
      estado: 1
    });
  }

  private createFormEmpresa(): FormGroup {
    return this.fb.group({
      nit: [''],
      digito: [''],
      nombre: [''],
      direccion: [''],
      ciudad: [''],
      telefono: ['', this.getTelefonoValidators()],
      celular: ['', this.getTelefonoValidators()],
      email: [''],
      observaciones: [''],
      eps: [false],
      arl: [false],
      afp: [false],
      ces: [false],
      ccf: [false],
      bancos: [false],
      transporte: [false],
      colegio: [false],
      cda: [false],
      taller: [false],
      eds: [false],
      contratista: [false],
      proveedor: [false],
      aseguradora: [false],
      almacen: [false],
      serviteca: [false],
      estado: [1],
    });
  }

  private createFormClase(): FormGroup {
    return this.fb.group({
      tipos: [''],
      estado: ['1'],
    });
  }

  private getTelefonoValidators(): ValidatorFn[] {
    return [
      Validators.min(1000000),
      Validators.max(9999999999),
      Validators.maxLength(10),
      Validators.pattern(/^\d{0,10}$/)
    ];
  }

  getNombreCompleto(item: any): string {
  if (!item) return '';

  const partes = [
    item.primernombre,
    item.segundonombre,
    item.papellidos,
    item.seapellidos
  ];

  const nombreCompleto = partes.filter(p => !!p).join(' ').toUpperCase();
  return `${item.cedula || ''} - ${nombreCompleto}`;
}
searchConductor = (term: string, item: any): boolean => {
  if (!term || !item) return false;

  const nombreCompleto = [
    item.primernombre,
    item.segundonombre,
    item.papellidos,
    item.seapellidos
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  const cedula = item.cedula?.toString().toLowerCase() || '';

  return nombreCompleto.includes(term.toLowerCase()) || cedula.includes(term.toLowerCase());
};
buscarPropietario(term: string, item: any): boolean {
  if (!term) return true;
  term = term.toLowerCase();

  const nombreCompleto = `${item.primernombre} ${item.segundonombre} ${item.papellidos} ${item.seapellidos}`.toLowerCase();
  const cedula = (item.cedula || '').toString().toLowerCase();

  return nombreCompleto.includes(term) || cedula.includes(term);
}

  onPropietarioChange(cedulaSeleccionada: any): void {
    const titularControl = this.formNuevo.get('titular');
    if (!cedulaSeleccionada) {
      titularControl?.setValue('');
      return;
    }

    const cedula =
      typeof cedulaSeleccionada === 'object'
        ? cedulaSeleccionada?.cedula
        : cedulaSeleccionada;

    const propietario =
      typeof cedulaSeleccionada === 'object' && cedulaSeleccionada?.cedula
        ? cedulaSeleccionada
        : this.propietarios?.find((p: any) => String(p.cedula) === String(cedula));

    if (!propietario) {
      titularControl?.setValue('');
      return;
    }

    const nombreCompleto = [
      propietario.primernombre,
      propietario.segundonombre,
      propietario.papellidos,
      propietario.seapellidos
    ]
      .filter((valor: any) => !!valor)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();

    titularControl?.setValue(nombreCompleto);
  }

 onRelacionChange(item: any): void {
   const relacionSeleccionada = this.obtenerRelacionSeleccionada(item);
   const textoRelacion = String(relacionSeleccionada?.relacion || '')
    .toLowerCase()
    .normalize('NFD').replace(/\p{Diacritic}/gu, '')
    .trim();

   this.mostrarFechaConvenio = Number(relacionSeleccionada?.id) === 8 || textoRelacion === 'convenios';
   this.aplicarEmpresaAdministrativaPorRelacion(relacionSeleccionada);

    const convenioControl = this.formNuevo.get('convenio');

    if (this.mostrarFechaConvenio) {
      convenioControl?.setValidators([Validators.required]);
    } else {
      convenioControl?.clearValidators();
      convenioControl?.setValue(null);
      
    }

    convenioControl?.updateValueAndValidity();
  }

  private obtenerRelacionSeleccionada(item: any): any {
    if (item && typeof item === 'object') {
      return item;
    }

    const idRelacion = Number(item);
    if (Number.isNaN(idRelacion)) {
      return null;
    }

    return this.relaciones?.find((r: any) => Number(r.id) === idRelacion) || null;
  }

  private cargarEmpresaAdministrativa(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (data: any[]) => {
        this.empresaAdministrativaNit = data?.[0]?.nit ? String(data[0].nit) : null;
        this.empresaAdministrativaNombre = this.extraerNombreEmpresaAdministrativa(data?.[0]);
        this.asegurarPropietarioEmpresaAdministrativa();
        if (this.autoSeleccionEmpresaAdministrativaPendiente && this.empresaAdministrativaNit) {
          this.formNuevo.get('nitEmpresa')?.setValue(this.empresaAdministrativaNit);
          this.formNuevo.get('Idpropietario')?.setValue(this.obtenerValorPropietarioAdministrativo());
          this.autoSeleccionEmpresaAdministrativaPendiente = false;
        }
      },
      error: (err) => {
        console.error('Error al cargar empresa administrativa:', err);
        this.empresaAdministrativaNit = null;
        this.autoSeleccionEmpresaAdministrativaPendiente = false;
      }
    });
  }

  private aplicarEmpresaAdministrativaPorRelacion(relacionSeleccionada: any): void {
    const relacion = String(relacionSeleccionada?.relacion || '')
      .toLowerCase()
      .normalize('NFD').replace(/\p{Diacritic}/gu, '')
      .trim();

    const esAfiliado = relacion.includes('afiliado');
    const esPropio = relacion.includes('propio');
    const esAfiliadoOPropio = esAfiliado || esPropio;

    if (!esAfiliadoOPropio) {
      const propietarioActual = this.formNuevo.get('Idpropietario')?.value;
      this.autoSeleccionEmpresaAdministrativaPendiente = false;
      this.formNuevo.get('nitEmpresa')?.setValue(null);
      if (this.empresaAdministrativaNit && String(propietarioActual) === String(this.empresaAdministrativaNit)) {
        this.formNuevo.get('Idpropietario')?.setValue(null);
      }
      return;
    }

    if (!this.empresaAdministrativaNit) {
      this.autoSeleccionEmpresaAdministrativaPendiente = true;
      this.cargarEmpresaAdministrativa();
      return;
    }

    this.asegurarPropietarioEmpresaAdministrativa();
    this.formNuevo.get('nitEmpresa')?.setValue(this.empresaAdministrativaNit);

    if (esPropio) {
      this.formNuevo.get('Idpropietario')?.setValue(this.obtenerValorPropietarioAdministrativo());
      return;
    }

    const propietarioActual = this.formNuevo.get('Idpropietario')?.value;
    if (this.empresaAdministrativaNit && String(propietarioActual) === String(this.empresaAdministrativaNit)) {
      this.formNuevo.get('Idpropietario')?.setValue(null);
    }
  }

  private extraerNombreEmpresaAdministrativa(administracion: any): string {
    const candidatos = [
      administracion?.nombre,
      administracion?.razonSocial,
      administracion?.razon_social,
      administracion?.nombreEmpresa,
      administracion?.empresa,
    ];

    const encontrado = candidatos.find((valor) => typeof valor === 'string' && valor.trim());
    return encontrado ? String(encontrado).trim() : 'EMPRESA ADMINISTRATIVA';
  }

  private obtenerValorPropietarioAdministrativo(): any {
    const propietario = this.propietarios?.find((p: any) =>
      String(p?.cedula) === String(this.empresaAdministrativaNit)
    );

    return propietario?.cedula ?? this.empresaAdministrativaNit;
  }

  private asegurarPropietarioEmpresaAdministrativa(): void {
    if (!Array.isArray(this.propietarios) || !this.empresaAdministrativaNit) {
      return;
    }

    const existe = this.propietarios.some((p: any) =>
      String(p?.cedula) === String(this.empresaAdministrativaNit)
    );

    if (existe) {
      return;
    }

    this.propietarios = [
      ...this.propietarios,
      {
        cedula: this.empresaAdministrativaNit,
        primernombre: this.empresaAdministrativaNombre || 'EMPRESA',
        segundonombre: '',
        papellidos: '',
        seapellidos: '',
      },
    ];
  }

    private cargarCiudades(): void {
    forkJoin({
      municipios: this.dataService.getDatos(),
    }).subscribe(
      (resultados) => {
        this.municipios = resultados.municipios;
      },
      (error) => this.handleError(error)
    );
  }

  private handleError(error: any): void {
    console.error('Error al obtener datos:', error);
  }
  validarTipoEmpresaSeleccionado(): boolean {
    const controles = this.formEmpresa.controls;
    const algunoSeleccionado = Object.keys(controles).some(key => controles[key].value === true);
    if (!algunoSeleccionado) {
      this.mostrarAlerta("Campo requerido", "Selecciona al menos un tipo de empresa", "info");
    }
    return algunoSeleccionado;
  }

  limitarLongitud(event: Event, max: number) {
    const input = event.target as HTMLInputElement;
    if (input.value.length > max) {
      input.value = input.value.slice(0, max);
      // Actualiza el FormControl asociado
      const controlName = input.getAttribute('formControlName');
      if (controlName) {
        this.formEmpresa.get(controlName)?.setValue(input.value);
      }
    }
  }

   /**
     * Obtiene la fecha actual en formato YYYY-MM-DD (zona horaria local de Colombia)
     * @returns string - Fecha actual formateada
     */
    private getTodayDate(): string {
      const today = new Date();
      
      // Obtener la fecha local ajustada para Colombia (UTC-5)
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    }
  
    /**
     * Configura la validación delayed para el campo de afiliación
     */
    private setupAfiliacionValidation(): void {
      const afiliacionControl = this.formNuevo.get('afiliacion');
      if (afiliacionControl) {
        afiliacionControl.setValidators([this.validarFechaAfiliacion.bind(this)]);
        afiliacionControl.updateValueAndValidity();
      }
    }
  
    /**
     * Maneja el cambio de fecha de afiliación para permitir entrada por teclado
     * @param event - Event del input
     */
    onFechaAfiliacionChange(event: Event): void {
      const input = event.target as HTMLInputElement;
      const valor = input.value;
      const afiliacionControl = this.formNuevo.get('afiliacion');
      
      if (afiliacionControl) {
        // Marcar como touched para activar validaciones visuales
        afiliacionControl.markAsTouched();
        
        // Permitir que el usuario escriba la fecha
        afiliacionControl.setValue(valor, { emitEvent: false });
        
        // Validar después de un pequeño delay para permitir completar la escritura
        setTimeout(() => {
          afiliacionControl.updateValueAndValidity();
        }, 300);
      }
    }
  
    /**
     * Validador personalizado para fecha de afiliación
     * @param control - AbstractControl
     * @returns ValidationErrors | null
     */
    private validarFechaAfiliacion(control: AbstractControl): {[key: string]: any} | null {
      const valor = control.value;
      
      // Si no hay valor, no es error (campo opcional)
      if (!valor) {
        return null;
      }
  
      // Verificar que la fecha sea válida antes de continuar
      const fechaAfiliacion = new Date(valor);
      
      // Si la fecha no es válida, no mostrar error para permitir que el usuario termine de escribir
      if (isNaN(fechaAfiliacion.getTime())) {
        return null;
      }
  
      const fechaActual = new Date();
      const fechaMinima = new Date('1990-01-01'); // Fecha mínima permitida
  
      // Resetear las horas para comparar solo fechas
      fechaActual.setHours(23, 59, 59, 999);
      fechaAfiliacion.setHours(0, 0, 0, 0);
      fechaMinima.setHours(0, 0, 0, 0);
  
      // Debug: Log para verificar que la validación se ejecuta
      console.log('Validando fecha afiliación:', {
        valor,
        fechaAfiliacion,
        fechaActual,
        esFutura: fechaAfiliacion > fechaActual,
        esMuyAntigua: fechaAfiliacion < fechaMinima
      });
  
      if (fechaAfiliacion > fechaActual) {
       // console.log('Error: Fecha futura detectada');
        return { 'fechaFutura': { valor: valor, actual: fechaActual } };
      }
  
      if (fechaAfiliacion < fechaMinima) {
       // console.log('Error: Fecha muy antigua detectada');
        return { 'fechaMuyAntigua': { valor: valor, minima: fechaMinima } };
      }
  
      //console.log('Fecha válida');
      return null;
    }

    /**
     * Marca todos los campos del formulario como touched para mostrar errores de validación
     * @param formGroup - FormGroup a marcar
     */
    private markFormGroupTouched(formGroup: FormGroup): void {
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);
        if (control) {
          control.markAsTouched();
          
          if (control instanceof FormGroup) {
            this.markFormGroupTouched(control);
          }
        }
      });
    }

    /**
     * Valida campos obligatorios específicos con mensajes personalizados
     * @returns boolean - true si todos los campos son válidos
     */
    private validarCamposObligatorios(): boolean {
      const errores: string[] = [];

      // Validar servicio
      if (!this.formNuevo.get('servicio')?.value) {
        errores.push('Tipo de servicio es obligatorio');
      }

      // Validar placa
      const placa = this.formNuevo.get('placa')?.value;
      if (!placa) {
        errores.push('La placa es obligatoria');
      } else if (!/^[A-Z0-9]{6}$/.test(placa)) {
        errores.push('La placa debe tener exactamente 6 caracteres alfanuméricos');
      }

      // Validar número interno
      if (!this.formNuevo.get('interno')?.value) {
        errores.push('El número interno es obligatorio');
      }

      // Validar empresa
      if (!this.formNuevo.get('nitEmpresa')?.value) {
        errores.push('La empresa es obligatoria');
      }

      // Validar clase
      if (!this.formNuevo.get('clase')?.value) {
        errores.push('La clase del vehículo es obligatoria');
      }

      // Validar marca
      if (!this.formNuevo.get('marca')?.value) {
        errores.push('La marca es obligatoria');
      }

      // Validar modelo
      if (!this.formNuevo.get('modelo')?.value) {
        errores.push('El modelo es obligatorio');
      }

      // Validar relación
      if (!this.formNuevo.get('relacion')?.value) {
        errores.push('La relación es obligatoria');
      }

      // Validar contraseña
    //  if (!this.formNuevo.get('password')?.value) {
     //   errores.push('La contraseña es obligatoria');
     // }

      // Validar kilometraje
      const kilometraje = this.formNuevo.get('kilometraje')?.value;
      if (kilometraje === null || kilometraje === undefined || kilometraje < 0) {
        errores.push('El kilometraje debe ser un número válido mayor o igual a 0');
      }

      // Validar fecha de afiliación
      const afiliacion = this.formNuevo.get('afiliacion');
      if (afiliacion?.errors) {
        if (afiliacion.errors['fechaFutura']) {
          errores.push('La fecha de afiliación no puede ser futura');
        }
        if (afiliacion.errors['fechaMuyAntigua']) {
          errores.push('La fecha de afiliación es muy antigua (mínimo: 01/01/1990)');
        }
      }

      // Si hay errores, mostrar mensaje
      if (errores.length > 0) {
        const mensaje = 'Errores de validación:\n• ' + errores.join('\n• ');
        this.mostrarAlerta('Errores de validación', mensaje, 'error');
        return false;
      }

      return true;
    }


  /**
   * Rellena el número interno con ceros a la izquierda hasta tener 3 dígitos.
   * Si el valor no es numérico, lo retorna como string sin cambios.
   */
  padNumeroInterno(valor: any): string {
    if (valor === null || valor === undefined) return '';
    const num = Number(valor);
    if (isNaN(num)) return String(valor);
    if (num < 10) {
      return '000' + num;
    } else if (num >= 10 && num < 100) {
      return '00' + num;
    } else if (num >= 100 && num < 1000) {
      return '0' + num;
    } else {
      return num.toString();
    }
  }

  cargarSiniestroByPlaca(placa: string): void {
    this.siniestrosService.getSiniestroByPlaca(placa).subscribe({
    next: (data) => {
      this.siniestros = data;
      this.siniestrosDisponibles = this.siniestros.length > 0;
    },
    error: (err) => {
      console.error("Error cargando siniestros", err);
      this.siniestros = []; // limpia en caso de error
      this.siniestrosDisponibles = false;
    }
  });

}

editarSiniestro(siniestro: Siniestro): void {
  Swal.fire({
    title: "Editar siniestro",
    text: `¿Desea editar el siniestro ${siniestro.consecutivo}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, editar",
    cancelButtonText: "Cancelar"
  }).then((result) => {
    if (result.isConfirmed) {
      this.router.navigate(['editar/editar-siniestros-viales', siniestro.id]);
    }
  });
}

activarSiniestro(siniestro: Siniestro): void {
    Swal.fire({
      title: "Activar",
      text: `¿Desea activar el siniestro ${siniestro.consecutivo}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.siniestrosService.activar(siniestro.id).subscribe({
          next: () => {
            Swal.fire("Éxito", "Siniestro activado correctamente", "success");
            this.cargarSiniestroByPlaca(this.placaSeleccionada);
          },
          error: (err) =>
            Swal.fire(
              "Error",
              err.error?.message || "No se pudo activar",
              "error",
            ),
        });
      }
    });
  }

  inactivarSiniestro(siniestro: Siniestro): void {
    Swal.fire({
      title: "Inactivar",
      text: `¿Desea inactivar el siniestro ${siniestro.consecutivo}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.siniestrosService.inactivar(siniestro.id).subscribe({
          next: () => {
            Swal.fire("Éxito", "Siniestro inactivado correctamente", "success");
            this.cargarSiniestroByPlaca(this.placaSeleccionada);
          },
          error: (err) =>
            Swal.fire(
              "Error",
              err.error?.message || "No se pudo inactivar",
              "error",
            ),
        });
      }
    });
  }

  esActivo(item: Siniestro): boolean {
    return String(item?.estado) === "1";
  }

  CrearSiniestro(siniestro: Siniestro): void {
  Swal.fire({
    title: "Crear siniestro",
    text: `¿Desea crear un nuevo siniestro?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, crear",
    cancelButtonText: "Cancelar"
  }).then((result) => {
    if (result.isConfirmed) {
      this.router.navigate(['siniestros-viales-crear/siniestros-viales-crear']);
    }
  });
}

}